var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_45",
    x: 0,
    y: 0,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.09
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "book",
    transform: "translate(-9.5 -172.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Audio_group_bg",
    transform: "translate(25 186)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15.5, -13.5)",
    filter: "url(#Rectangle_45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45-2",
    "data-name": "Rectangle 45",
    width: 65,
    height: 65,
    rx: 32.5,
    transform: "translate(13.5 10.5)",
    fill: "#fe8901"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M2663.058,316.511a.746.746,0,0,0-.782-.729c-.027,0-.522.027-1.332.1v-.892a.746.746,0,0,0-.782-.744c-.386.019-9.4.507-14.253,3.6-4.857-3.1-13.867-3.584-14.253-3.6a.745.745,0,0,0-.782.744v.892c-.81-.075-1.3-.1-1.332-.1a.729.729,0,0,0-.545.2.749.749,0,0,0-.238.53l-.57,27.228a.745.745,0,0,0,.916.741,37.417,37.417,0,0,1,16.361.2.751.751,0,0,0,.2.026h.007a.763.763,0,0,0,.208-.034c.01,0,.021,0,.031-.008s.021,0,.031.008a.773.773,0,0,0,.209.034h.007a.756.756,0,0,0,.2-.026,37.416,37.416,0,0,1,16.36-.2.745.745,0,0,0,.915-.741Zm-16.158,2.476c3.768-2.286,10.308-3.008,12.554-3.194v24.082a31.071,31.071,0,0,0-12.554,2.853Zm-14.536-3.194c2.245.186,8.783.906,12.554,3.194v23.741a31.063,31.063,0,0,0-12.554-2.853Zm-2.664,27.031.534-25.5c.184.015.4.034.64.057v23.23a.745.745,0,0,0,.745.745,31.167,31.167,0,0,1,7.287.862A36.344,36.344,0,0,0,2629.7,342.824Zm23.212-.605a31.189,31.189,0,0,1,7.288-.862.745.745,0,0,0,.745-.745v-23.23c.24-.023.456-.042.64-.057l.534,25.5A36.361,36.361,0,0,0,2652.911,342.219Z",
    transform: "translate(-2590.189 -114.247)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.5251bb0c575fefe6a32b809600c8ed93.svg";
export { ForwardRef as ReactComponent };